var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 899,
    viewBox: "0 0 1440 899",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_8011)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 899,
    fill: "url(#paint0_linear_263_8011)",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_263_8011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 696.818C1351.89 609.281 1215.1 621.937 1025.45 768.534C701.538 1018.92 546.294 533.345 0 723.184",
    stroke: "#FE0459",
    strokeOpacity: 0.49,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_263_8011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1441 707.703C1352.89 600.705 1090.65 592.606 901 771.793C577.084 1077.84 544.294 443.181 -2 675.222",
    stroke: "url(#paint1_linear_263_8011)",
    strokeWidth: 5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_263_8011",
    x: -10.4922,
    y: 630.5,
    width: 1461.55,
    height: 223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_263_8011"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_263_8011",
    x: -12.9766,
    y: 610.5,
    width: 1465.91,
    height: 259.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_263_8011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_263_8011",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCE8",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE0459",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_263_8011",
    x1: 737.5,
    y1: 759.5,
    x2: 719.5,
    y2: 857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FE0459",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_8011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 899,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/layout.002490ec0b705721db8b47f505eae47e.svg";
export { ForwardRef as ReactComponent };